module.exports = __webpack_public_path__ + "img/ae.a1195174.svg";